// extracted by mini-css-extract-plugin
export default {"actionWrapper":"buttons-section_actionWrapper__W63jn"};